import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { OrganizationDTO } from './organization.dto';
import { OrganizationDetailDTO } from './organzation-detail.dto';
import { CompareGroupDTO } from './compare-group.dto';
import { CompareGroupMemberDTO, CompareGroupMemberListDTO, SelfCompareGroupMemberDTO } from './compare-group-member.dto';
import { BatchDTO } from './batch.dto';

@Injectable({
  providedIn: 'root'
})
export class SelfCompareGroupService {

  constructor(private http: HttpClient) { }

  getSelfCompareGroups(orgId: number): Observable<CompareGroupDTO[]> {
    const apiUrl = environment.baseAPIURL + `GetSelfCompareGroups?orgID=${orgId}`;
    return this.http.get<CompareGroupDTO[]>(apiUrl);
  }

  getSelfCompareGroupMembers(compareGroupId: number): Observable<SelfCompareGroupMemberDTO[]> {
    const apiUrl = environment.baseAPIURL + `GetSelfCompareGroupMembers?compareGroupId=${compareGroupId}`;
    return this.http.get<SelfCompareGroupMemberDTO[]>(apiUrl);
  }

  deleteCompareGroup(id: number): Observable<any> {
    const apiUrl = environment.baseAPIURL + `DeleteSelfCompareGroup`;
    return this.http.post(apiUrl, id);
  }

  updateCompareGroup(memberList: CompareGroupMemberListDTO): Observable<any> {
    const apiUrl = environment.baseAPIURL + `SaveSelfCompareGroup`;
    return this.http.post(apiUrl, memberList);
  }

  getBatchList(orgId: number): Observable<BatchDTO[]> {
    const apiUrl = environment.baseAPIURL + `GetBatchesFromOrg?orgID=${orgId}`;
    return this.http.get<BatchDTO[]>(apiUrl);
  }
}
